import Vue from "vue";
import Router from "vue-Router";
import Index from "@/components/index";

// 走进湿地
import StepInWetland from "@/components/stepInWetland/stepInWetland";
import WetlandDescription from "@/components/stepInWetland/wetlandDescription";
import Resource from "@/components/stepInWetland/resource";
import ResourcePost from "@/components/stepInWetland/resource_post";
// 湿地一张图
import WetlandOneMap from "@/components/wetlandOneMap/wetlandOneMap";
// 环境监测
import EnvironmentMonitor from "@/components/environmentMonitor/environmentMonitor";
// 预警发布
import WarningIssued from "@/components/warningIssued/warningIssued";
// 视频监控
import VideoSurveillance from "@/components/videoSurveillance/videoSurveillance";
// 巡护展示
import PatrolDisplay from "@/components/patrolDisplay/patrolDisplay";
// 虚拟体验
import VirtualExperience from "@/components/virtualExperience/virtualExperience";
// 科普宣教
import PopularSciencePost from "@/components/popularScience/popularScience_post";
// 关于我们
import About from "@/components/about/about";

Vue.use(Router);

let router = new Router({
  routes: [
    // 首页
    {
      path: "/",
      component: Index,
      name: "Index"
    },
    // 走进湿地
    {
      path: "/stepInWetland/index/:type",
      component: () => import("@/components/stepInWetland/index"),
      name: "StepInWetlandIndex",
      props: true
    },
    {
      path: "/stepInWetland/stepInWetland",
      component: StepInWetland,
      name: "StepInWetland"
    },
    {
      path: "/stepInWetland/wetlandDescription",
      component: WetlandDescription,
      name: "WetlandDescription"
    },
    {
      path: "/stepInWetland/tourismResource",
      component: () => import("@/components/stepInWetland/tourismResource"),
      name: "TourismResource"
    },
    {
      path: "/stepInWetland/animalResource",
      component: () => import("@/components/stepInWetland/animalResource"),
      name: "AnimalResource"
    },
    {
      path: "/stepInWetland/plantResource",
      component: () => import("@/components/stepInWetland/plantResource"),
      name: "PlantResource"
    },
    // {
    //   path: "/stepInWetland/resource/:type",
    //   component: Resource,
    //   name: "Resource",
    //   props: true
    // },
    {
      path: "/stepInWetland/resource_post",
      component: ResourcePost,
      name: "ResourcePost"
    },
    // 湿地管控
    {
      path: "/wetlandOneMap/index/:type",
      component: () => import("@/components/wetlandOneMap/index"),
      name: "WetlandOneMapIndex",
      props: true
    },
    // 湿地一张图
    {
      path: "/wetlandOneMap/wetlandOneMap",
      component: WetlandOneMap,
      name: "WetlandOneMap"
    },
    // 环境监测
    {
      path: "/environmentMonitor/environmentMonitor",
      component: EnvironmentMonitor,
      name: "EnvironmentMonitor"
    },
    // 预警发布
    {
      path: "/warningIssued/warningIssued",
      component: WarningIssued,
      name: "WarningIssued"
    },
    // 视频监控
    {
      path: "/videoSurveillance/videoSurveillance",
      component: VideoSurveillance,
      name: "VideoSurveillance"
    },
    // 巡护展示
    {
      path: "/patrolDisplay/patrolDisplay",
      component: PatrolDisplay,
      name: "PatrolDisplay"
    },
    // 虚拟体验
    {
      path: "/virtualExperience/virtualExperience",
      component: VirtualExperience,
      name: "VirtualExperience"
    },
    // 科普宣教
    {
      path: "/popularScience/index/:type",
      component: () => import("@/components/popularScience/index"),
      name: "PopularScienceIndex",
      props: true
    },
    {
      path: "/popularScience/popularScience4",
      component: () => import("@/components/popularScience/popularScience4"),
      name: "PopularScience4"
    },
    {
      path: "/popularScience/popularScience5",
      component: () => import("@/components/popularScience/popularScience5"),
      name: "PopularScience7"
    },
    {
      path: "/popularScience/popularScience6",
      component: () => import("@/components/popularScience/popularScience6"),
      name: "PopularScience7"
    },
    {
      path: "/popularScience/popularScience7",
      component: () => import("@/components/popularScience/popularScience7"),
      name: "PopularScience7"
    },
    // {
    //   path: "/popularScience/popularScience/:type",
    //   component: PopularScience,
    //   name: "PopularScience",
    //   props: true
    // },
    {
      path: "/popularScience/popularScience_post",
      component: PopularSciencePost,
      name: "PopularSciencePost"
    },
    // 湿地管控
    {
      path: "/about/index/:type",
      component: () => import("@/components/about/index"),
      name: "AboutIndex",
      props: true
    },
    // 关于我们
    {
      path: "/about/about",
      component: About,
      name: "About"
    },
    // 走进湿地
    {
      path: "/popularScience/journalismIndex/:type",
      component: () =>
        import("@/components/popularScience/journalismIndex"),
      name: "PopularScienceJournalismIndexIndex",
      props: true
    }
  ]
});

// router.routesArr = [];
// // 后退到上一层页面，不是上一个历史
// router.backward = function(stepNum) {
//   typeof stepNum !== "number" && (stepNum = 1);
//   stepNum = Math.abs(stepNum);
//   let index = router.routesArr.length - 1 - stepNum;
//   let route = router.routesArr[0];
//   if (index > 0) {
//     route = router.routesArr[index];
//   }

//   router.push({
//     name: route.name,
//     // path: route.path,
//     params: { isBack: true },
//     query: route.query
//   });
// };
// // 判断某一个路由是否在轨迹中出现
// router.getIndexOf = path => {
//   for (let i in router.routesArr) {
//     let route = router.routesArr[i];
//     if (route.path === path) {
//       return i;
//     }
//   }
//   return -1;
// };
// // 记录用户浏览页面的地址的轨迹，只保留单一节点
// router.afterEach((to, from) => {
//   let index = router.getIndexOf(to.path);
//   if (index !== -1) {
//     router.routesArr.splice(index, 900);
//   }
//   router.routesArr.push(to);
// });

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js